var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"printTable"}},[_c('report-header',[_c('h2',[_vm._v(" "+_vm._s(_vm.reportHeaderText)+" ")])]),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.tableHeaders,"items":_vm.tableData,"sort-by":"Date","sort-desc":"","items-per-page":-1}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }